import { render, staticRenderFns } from "./CardMaquina.vue?vue&type=template&id=31c996f2&scoped=true&"
import script from "./CardMaquina.vue?vue&type=script&lang=js&"
export * from "./CardMaquina.vue?vue&type=script&lang=js&"
import style0 from "./CardMaquina.vue?vue&type=style&index=0&id=31c996f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c996f2",
  null
  
)

export default component.exports